import { render, staticRenderFns } from "./StationProduct.vue?vue&type=template&id=57bd3b02&"
import script from "./StationProduct.vue?vue&type=script&lang=js&"
export * from "./StationProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports